import { LOCALES } from '../../constants/intl';
import { Messages } from '../../types';
import { AppState } from '../reducers/root';

export const getCurrentLocaleName = (state: AppState): LOCALES =>
  state.intl.currentLocale;

export const getCurrentLocaleMessages = (
  state: AppState
): Messages | undefined =>
  state.intl.localeData[getCurrentLocaleName(state)]?.messages;
